/**
 * Hooks API index - Export all API hooks for clean imports
 */

// Header and footer hooks
export { useFooterData } from './useFooter';
export { useHeaderData } from './useHeader';

// Landing page hook
export { useLandingPageData } from './useLandingPage';

// TODO: Add other hooks as they are created
// export { useAboutPage } from './useAboutPage';
// export { useServices } from './useServices';
// export { useContact } from './useContact';
